export default "__VITE_ASSET__B_MuxfDV__"